import React, { useMemo } from "react";
import FormSelect from "../FormSelect";
import { useFetchVulnerabilityTypesQuery } from "../../../services/clientfactfind";

const VulnerabilityTypesSelect = ({ options, divisionId = null, includeNoneOption = false, ...rest }) => {
    const { data, error, isError, isLoading, isFetching } = useFetchVulnerabilityTypesQuery({ });

    const displayOptions = useMemo(() => {
        let options = includeNoneOption ? [{ label: "None", value: null }] : [];

        if (isError || isFetching)
            return options;

        return [...options, ...data];
    }, [data, includeNoneOption, isError, isFetching]);

    return <FormSelect
        options={displayOptions.sort((a, b) => a.label > b.label ? 1 : -1)}
        isLoadingOptions={isLoading || isFetching}
        {...rest}
    />
};

export default VulnerabilityTypesSelect;